<ion-header>
  <ion-toolbar color="white-0">
    <ion-buttons slot="end">
      <app-modal-back
        icon="close"
        ariaLabel="close"
      ></app-modal-back>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <mable-heading>Thanks for your feedback</mable-heading>
  <div class="ion-padding-horizontal ion-padding-bottom">
    <p class="ion-margin-bottom">
      Your feedback is valuable to us and we'll use it to make improvements. Thank you for taking the time to share your
      thoughts.
    </p>
  </div>
  <mable-button
    expand="block"
    class="ion-margin-horizontal"
    (onClick)="dismiss()"
  >
    Done
  </mable-button>
</ion-content>
